function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faVolumeMute, faVolumeLow, faVolumeHigh, faForwardStep, faBackwardStep, faHeart } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useIntl } from 'react-intl';
import PlayIcon from '../PlayIcon';
import { motion, useAnimationControls } from 'framer-motion';
import { faHeartOutline } from '../icons/fontawesome/HeartOutline';
import useIntlMemo from '@/hooks/useIntlMemo';
import { ActionIcon, Slider, Tooltip } from '@mantine/core';
import styles from './SongControls.module.scss';
import Icon, { IconSizes } from '../Icon';
function VolumeSlider(_param) {
    var onVolume = _param.onVolume, value = _param.value, props = _object_without_properties(_param, [
        "onVolume",
        "value"
    ]);
    var intl = useIntl();
    return /*#__PURE__*/ _jsx(Slider, _object_spread({
        min: 0,
        max: 100,
        thumbSize: 14,
        thumbChildren: null,
        size: "sm",
        "aria-label": intl.formatMessage({
            id: "y867Vs",
            defaultMessage: [
                {
                    type: 0,
                    value: "Volume"
                }
            ]
        }),
        value: Math.floor(value * 100),
        onChange: function(value) {
            return onVolume === null || onVolume === void 0 ? void 0 : onVolume(value / 100);
        },
        label: function(value) {
            return "".concat(Math.floor(value), "%");
        }
    }, props));
}
function SongControls(_param) {
    var _param_isPlaying = _param.isPlaying, isPlaying = _param_isPlaying === void 0 ? false : _param_isPlaying, _param_isRepeated = _param.isRepeated, isRepeated = _param_isRepeated === void 0 ? true : _param_isRepeated, _param_isShuffled = _param.isShuffled, isShuffled = _param_isShuffled === void 0 ? false : _param_isShuffled, _param_isMuted = _param.isMuted, isMuted = _param_isMuted === void 0 ? false : _param_isMuted, _param_hasHistory = _param.hasHistory, hasHistory = _param_hasHistory === void 0 ? false : _param_hasHistory, _param_hasMore = _param.hasMore, hasMore = _param_hasMore === void 0 ? false : _param_hasMore, _param_volume = _param.volume, volume = _param_volume === void 0 ? 0 : _param_volume, initialPlayerPosition = _param.playerPosition, playerDuration = _param.playerDuration, currentSong = _param.currentSong, _param_isBuffering = _param.isBuffering, isBuffering = _param_isBuffering === void 0 ? false : _param_isBuffering, _param_inPlaylist = _param.inPlaylist, inPlaylist = _param_inPlaylist === void 0 ? false : _param_inPlaylist, _param_loadingInPlaylist = _param.loadingInPlaylist, loadingInPlaylist = _param_loadingInPlaylist === void 0 ? false : _param_loadingInPlaylist, onToggleInPlaylist = _param.onToggleInPlaylist, onSeek = _param.onSeek, onPlayToggle = _param.onPlayToggle, onMuteToggle = _param.onMuteToggle, onNextSong = _param.onNextSong, onLastSong = _param.onLastSong, onShuffle = _param.onShuffle, onVolume = _param.onVolume, onRepeat = _param.onRepeat, onClearQueue = _param.onClearQueue, onEditSettings = _param.onEditSettings, onImportPlaylist = _param.onImportPlaylist, onClearPlaylist = _param.onClearPlaylist, props = _object_without_properties(_param, [
        "isPlaying",
        "isRepeated",
        "isShuffled",
        "isMuted",
        "hasHistory",
        "hasMore",
        "volume",
        "playerPosition",
        "playerDuration",
        "currentSong",
        "isBuffering",
        "inPlaylist",
        "loadingInPlaylist",
        "onToggleInPlaylist",
        "onSeek",
        "onPlayToggle",
        "onMuteToggle",
        "onNextSong",
        "onLastSong",
        "onShuffle",
        "onVolume",
        "onRepeat",
        "onClearQueue",
        "onEditSettings",
        "onImportPlaylist",
        "onClearPlaylist"
    ]);
    var intl = useIntl();
    var controls = useAnimationControls();
    var volumeIcon = React.useMemo(function() {
        if (volume === 0) {
            return faVolumeMute;
        } else if (volume <= 0.5) {
            return faVolumeLow;
        } else {
            return faVolumeHigh;
        }
    }, [
        volume
    ]);
    React.useEffect(function() {
        if (playerDuration == null || initialPlayerPosition == null || currentSong == null) {
            controls.stop();
            controls.set({
                width: '0%'
            });
            return;
        }
        var durationLeft = playerDuration - initialPlayerPosition;
        var progressPercent = initialPlayerPosition / playerDuration;
        if (!isPlaying || isBuffering) {
            controls.stop();
            return;
        }
        controls.start({
            width: [
                "".concat(progressPercent * 100, "%"),
                '100%'
            ],
            transition: {
                duration: durationLeft,
                ease: 'linear'
            }
        });
    }, [
        playerDuration,
        initialPlayerPosition,
        isPlaying,
        controls,
        currentSong,
        isBuffering
    ]);
    function handleOnSeek(event) {
        if (playerDuration == null || currentSong == null) {
            return;
        }
        var rect = event.currentTarget.getBoundingClientRect();
        var positionPercentage = (event.clientX - rect.left) / rect.width;
        var position = positionPercentage * playerDuration;
        onSeek === null || onSeek === void 0 ? void 0 : onSeek(position);
    }
    var addToPlaylistLabel = useIntlMemo(function(intl) {
        return inPlaylist ? intl.formatMessage({
            id: "fw9Ogq",
            defaultMessage: [
                {
                    type: 0,
                    value: "Remove from Playlist"
                }
            ]
        }) : intl.formatMessage({
            id: "JunmfI",
            defaultMessage: [
                {
                    type: 0,
                    value: "Add to Playlist"
                }
            ]
        });
    }, [
        inPlaylist
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.progressBar,
                onClick: handleOnSeek,
                children: /*#__PURE__*/ _jsx(motion.div, {
                    animate: controls,
                    className: styles.progress
                }, "progress")
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.controlsContainer,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.volumeControls,
                        children: [
                            /*#__PURE__*/ _jsx(ActionIcon, {
                                size: "lg",
                                "aria-label": isMuted ? intl.formatMessage({
                                    id: "W9355R",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Unmute"
                                        }
                                    ]
                                }) : intl.formatMessage({
                                    id: "x82IOl",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Mute"
                                        }
                                    ]
                                }),
                                onClick: function() {
                                    return onMuteToggle === null || onMuteToggle === void 0 ? void 0 : onMuteToggle();
                                },
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: volumeIcon
                                })
                            }),
                            /*#__PURE__*/ _jsx(VolumeSlider, {
                                className: styles.volumeSlider,
                                value: volume,
                                onVolume: onVolume
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.buttonGroup,
                        children: [
                            /*#__PURE__*/ _jsx(ActionIcon, {
                                size: "lg",
                                variant: "transparent",
                                color: "dark",
                                "aria-label": intl.formatMessage({
                                    id: "8heESb",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Last Song"
                                        }
                                    ]
                                }),
                                onClick: function() {
                                    return hasHistory && (onLastSong === null || onLastSong === void 0 ? void 0 : onLastSong());
                                },
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    icon: faBackwardStep,
                                    size: IconSizes.MD
                                })
                            }),
                            /*#__PURE__*/ _jsx(ActionIcon, {
                                variant: "inverse",
                                size: "lg",
                                radius: "full",
                                disabled: currentSong == null,
                                onClick: function() {
                                    return onPlayToggle === null || onPlayToggle === void 0 ? void 0 : onPlayToggle();
                                },
                                children: /*#__PURE__*/ _jsx(PlayIcon, {
                                    enabled: isPlaying
                                })
                            }),
                            /*#__PURE__*/ _jsx(ActionIcon, {
                                size: "lg",
                                color: "dark",
                                variant: "transparent",
                                "aria-label": intl.formatMessage({
                                    id: "UcSVVY",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Next Song"
                                        }
                                    ]
                                }),
                                onClick: function() {
                                    return hasMore && currentSong != null && (onNextSong === null || onNextSong === void 0 ? void 0 : onNextSong());
                                },
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    icon: faForwardStep,
                                    size: IconSizes.MD
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.songActions,
                        children: /*#__PURE__*/ _jsx(Tooltip, {
                            label: addToPlaylistLabel,
                            children: /*#__PURE__*/ _jsx(ActionIcon, {
                                size: "lg",
                                "aria-label": addToPlaylistLabel,
                                onClick: function() {
                                    return onToggleInPlaylist();
                                },
                                disabled: loadingInPlaylist,
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    icon: inPlaylist ? faHeart : faHeartOutline,
                                    size: IconSizes.SM
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
}
export default SongControls;
